import { useDeepMemo } from '@retailer-platform/shared-common'
import { useDomainMessages } from 'domains/retailer-collections/utils/domain/intl'
import { RetailerCollectionContentType } from 'domains/retailer-collections/utils/types'

type Option = {
  label: string
  value: RetailerCollectionContentType
  disabled: boolean
  tooltipMessage: string
}

export const useGetContentTypeOptions = (
  overrides: Partial<Record<RetailerCollectionContentType, Partial<Option>>> = {}
) => {
  const messages = useDomainMessages({
    contentTypeCollections: 'retailerCollectionsDomain.form.contentType.value.collections',
    contentTypeProducts: 'retailerCollectionsDomain.form.contentType.value.products',
    contentTypeProductEnabledTooltip:
      'retailerCollectionsDomain.form.contentType.product.enabledTooltip',
    contentTypeCollectionEnabledTooltip:
      'retailerCollectionsDomain.form.contentType.collection.enabledTooltip',
  })

  return useDeepMemo(
    () =>
      [
        {
          label: messages.contentTypeCollections,
          value: RetailerCollectionContentType.Collections,
          tooltipMessage: messages.contentTypeCollectionEnabledTooltip,
          disabled: false,
        },
        {
          label: messages.contentTypeProducts,
          value: RetailerCollectionContentType.Products,
          tooltipMessage: messages.contentTypeProductEnabledTooltip,
          disabled: false,
        },
      ].map(option => ({ ...option, ...overrides[option.value] })),
    [messages, overrides]
  )
}
